// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"04db76e3","527":"aa54aaa0"}[chunkId] + ".chunk.js";
};